import $ from 'jquery';
import _ from 'lodash';

import widgetFactory from '../widgetFactory';

const errorTemplate =
    '<span class="oc-tooltip oc-tooltip--bottom-right oc-tooltip--error  oc-form__errorTooltip  js-elementError-content"></span>',
  widgetName = 'elementError',
  errorClassname = 'has-error';

const widget = widgetFactory(widgetName, {
  options: {
    parentSelector: '.oc-form__row',
  },

  _create: function () {
    var options = this.options;

    this._super(widgetName);

    this.elements.$parent = options.parentSelector
      ? this.element.closest(options.parentSelector)
      : this.element.parent();

    this.element.parent().css({ position: 'relative' });

    this._injectErrorElement();
  },

  _injectErrorElement: function () {
    var template = _.template(errorTemplate),
      $element = $(template());

    $element.hide().insertAfter(this.element);

    this.elements.$errorElement = $element;
    this.elements.$errorContent = this.elements.$errorElement;
    this.hide();
  },

  setMessage: function (message) {
    this.elements.$errorContent.html(message);

    return this;
  },

  show: function () {
    this.elements.$errorElement.removeClass('is-hidden').show().position({
      my: 'left top',
      at: 'left bottom+11',
      of: this.elements.$parent,
    });

    this.elements.$parent.addClass(errorClassname);

    return this;
  },

  hide: function () {
    this.elements.$errorElement.addClass('is-hidden');
    this.elements.$parent.removeClass(errorClassname);

    return this;
  },
});

export default widget;
